import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Select2Multiple from 'v-select2-multiple-component';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import CONFIG from "@/assets/js/config.custom";
import SelectAllService from '@/services/SelectAllService';

export default {
  name: "reportCardGradingList",
  components: {
    MainLayout,
    Select2Multiple,
    Loading,
    AdvancedLaravelVuePaginate,
  },
  mixins: [SelectAllService],

  data() {
    return {
      isFilterOpen: false,
      isLoading: false,
      acdYearList: [{ id: 0, text: 'Select Academic Year' }],
      termList: [{ id: 0, text: 'Select Term' }],
      gradeList: [{ id: 0, text: 'Select Grade' }],
      searchData: {
        acdYearId: 0,
        termId: 0,
        gradeId: 0,
        studentName: '',
        studentNo: ''
      },
      gradingList: {
        data: [],
        total: 0,
        current_page: 1,
        per_page: 15,
        last_page: 1,
      },
      searchStatus: false,
      currentPage: 1,
      DISPLAY_STATUS: CONFIG.REPORT_CARD_DISPLAY_STATUS,
    };
  },

  watch: {
    'searchData.acdYearId'(newVal) {
      this.searchData.gradeId = 0;
      this.searchData.termId = 0;
      this.gradeList = [{ id: 0, text: 'Select Grade' }];
      this.termList = [{ id: 0, text: 'Select Term' }];
      if (!newVal) return;
      this.getTermListByAcademicYear(newVal);
      this.getGradeListByAcdYear(newVal);
    },
    
    'searchData.termId'(newVal) {
      if (!newVal) return;
    },
  },

  computed: {
    isPrincipalRole() {
      return Number(this.$store.state.user?.role) === CONFIG.ROLE.ID.PRINCIPAL;
    },

    canBatchUpdateStatus() {
      return this.can('REPORTCARD_GRADING_ITEM', 'batchUpdate');
    },

    canRevertStatus() {
      return this.isPrincipalRole && this.canBatchUpdateStatus;
    },
  },

  methods: {
    async getDropdownData() {
      await this.getParentAcdYearList();
    },

    async getParentAcdYearList() {
      try {
        const response = await axios.get('score-setting/parent-acd-year');
        if (response.data) {
          const defaultOption = [{ id: 0, text: 'Select Academic Year' }];
          this.acdYearList = defaultOption.concat(
            (response.data.data || []).map(item => ({
              id: item.id,
              text: item.period_name,
            }))
          );
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async getTermListByAcademicYear(acdYearId) {
      try {
        const response = await axios.get(`period/${acdYearId}/term/list`);
        if (response.data && response.data.terms) {
          const defaultOption = [{ id: 0, text: 'Select Term' }];
          this.termList = defaultOption.concat(
            response.data.terms.map(item => ({
              id: item.id,
              text: item.term_name,
              acd_year_id: acdYearId,
            }))
          );
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async getGradeListByAcdYear(acdYearId) {
      try {
        const response = await axios.get('campusGrade/listByAcdYear', {
          params: { acd_year_id: acdYearId },
        });
        if (response.data) {
          const defaultOption = [{ id: 0, text: 'Select Grade' }];
          this.gradeList = defaultOption.concat(
            (response.data.data || []).map(item => ({
              id: item.id,
              text: item.text,
            }))
          );
        }
      } catch (error) {
        this.handleError(error);
      }
    },

    async fetchAllList(page = 1) {
      this.searchStatus = false;
      this.isLoading = true;
      try {
        const response = await axios.get("/report-card-grading-item?page=" + page);
        if (response.data) {
          this.gradingList = response.data ?? response.data;
          this.currentPage = response.data.current_page;
          this.initCurrentCbs();
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    initCurrentCbs() {
      this.currentCbs = [];
      this.gradingList.data.forEach(row => {
        this.storeCurretCbs(row.id);
      });
    },

    async search(page = 1) {
      this.searchStatus = true;
      this.isLoading = true;
      try {
        const response = await axios.get('/report-card-grading-item', {
          params: {
            parent_acd_year_id: this.searchData.acdYearId || null,
            term_id: this.searchData.termId || null,
            campus_grade_id: this.searchData.gradeId || null,
            student_name: this.searchData.studentName,
            student_no: this.searchData.studentNo,
            page,
          },
        });
        if (response.data) {
          this.gradingList = response.data;
          this.currentPage = response.data.current_page;
          this.initCurrentCbs();
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    reset() {
      this.searchData = {
        acdYearId: 0,
        termId: 0,
        gradeId: 0,
        studentName: '',
        studentNo: ''
      };
      this.termList = [{ id: 0, text: 'Select Term' }];
      this.gradeList = [{ id: 0, text: 'Select Grade' }];
      this.gradingList = { data: [], total: 0, current_page: 1, per_page: 15, last_page: 1 };
      this.resetSelectedAll();
      this.getDropdownData();
      this.fetchAllList();
    },

    showDetail(id) {
      this.$router.push({ path: `/report-card-grading/${id}/info` });
    },

    showEdit(id) {
      this.$router.push({ path: `/report-card-grading/${id}/edit` });
    },

    handleError(error) {
      this.isLoading = false;
      if (error.response?.status == 422) {
        this.$notification.error(error.response.data.message, {
          timer: 3, position: "bottomCenter",
        });
        return;
      } else if (error.response && error.response.status === 401) {
        this.$store.commit('logout');
        window.location.replace('login');
      } else {
        this.$notification.error("Failed to update status.", {
          timer: 3, position: "bottomCenter",
        });
      }
    },

    async batchUpdateStatus(status) {
      if (!this.canBatchUpdateStatus) {
        this.$notification.error('You do not have permission to update status.', {
          timer: 3, position: "bottomCenter",
        });
        return;
      }

      if (Number(status) === CONFIG.REPORT_CARD_DISPLAY_STATUS_KEYS.DRAFT && !this.canRevertStatus) {
        this.$notification.error('Only Principal can change Approve back to Draft.', {
          timer: 3, position: "bottomCenter",
        });
        return;
      }

      if (this.isEmptySelected(this.gradingList.total)) {
        this.$notification.error('Please select at least one item to apply.', {
          timer: 3, position: "bottomCenter",
        });
        return;
      }

      const statusText = this.DISPLAY_STATUS[status];
      if (!window.confirm(`Apply ${statusText} for selected item(s)?`)) {
        return;
      }
      this.isLoading = true;
      try {
        const payload = {
          ids: [...this.selectedIds],
          selected_all: this.selectedAllToggle,
          status: status,
        };

        if (this.searchStatus && this.selectedAllToggle) {
          payload.parent_acd_year_id = this.searchData.acdYearId;
          payload.term_id = this.searchData.termId;
          payload.campus_grade_id = this.searchData.gradeId;
          payload.student_name = this.searchData.studentName;
          payload.student_no = this.searchData.studentNo;
        }

        await axios.post('/report-card-grading-item/batch-update-status', payload);
        
        this.$notification.success(`Status updated to ${statusText} successfully.`, {
          timer: 3, position: "bottomCenter",
        });
        
        this.resetSelectedAll();
        
        if (this.searchStatus) {
          this.search(this.gradingList.current_page);
        } else {
          this.fetchAllList(this.currentPage);
        }
      } catch (error) {
        this.handleError(error);
      } finally {
        this.isLoading = false;
      }
    },

    selectToggle(id, index) {
      this.selectToggleWithCount(id, index, this.gradingList.data.length);
    },
  },

  mounted() {
    this.isLoading = true;
    this.getDropdownData();
    this.fetchAllList();
  },
};
